<template>
  <div class="vs-component vs-con-input-label vs-input vs-input-primary">
    <label :for="id" class="vs-input--label">{{ label }}</label>
    <div class="vs-con-input">
      <input
        :id="id"
        :autofocus="autofocus"
        :name="name"
        :type="closedEyeIcon ? 'password' : 'text'"
        :value="value"
        :color="color"
        :ref="ref_link"
        @input="updateValue"
        @blur="$emit('blur')"
        @focus="$emit('focus')"
        class="vs-inputx vs-input--input normal" />
        <span class="icon" @click.prevent="closedEyeIcon = !closedEyeIcon">
          <vs-icon icon-pack="feather" :icon="closedEyeIcon ? 'icon-eye-off' : 'icon-eye'" />
        </span>
    </div>
    <span class="text-danger text-sm" v-show="error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  $_veeValidate: {
    name () {
      return this.name
    },
    value () {
      return this.value
    }
  },
  props: {
    value: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    ref_link: {
      type: String,
      required: false
    },
    error: {
      type: String,
      required: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: null,
      closedEyeIcon: true
    }
  },
  mounted () {
    this.id = this._uid
  },
  methods: {
    updateValue (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
input.vs-input--input.normal {
  letter-spacing: 4px;
  padding-right: 40px !important;
}
.icon {
  cursor: pointer;
  position: absolute;
  top: 9px;
  right: 10px;
  border: none;
  background: none;
  outline: none;
  i {
    font-size: 18px;
    color: #999;
  }
}
</style>
